import Vue from 'vue'
import router from '../router/index'

import axios from 'axios'
// import { slice } from 'lodash'
const CancelToken = axios.CancelToken
let axiosCancelFunc = null

// const server = 'http://52.36.161.178/api/v1' // DevTest3
const server = 'https://ui.hiqsolar.net/api/v1'
// const demoCache = {}

export default {
  get_headers() {
    return { 'X-session-key': Vue.cookie.get('qsession') }
  },

  handle_error(method, reqeust, err) {
    console.log('ERROR!')
    console.log(err)
    if (err.response.status > 400) {
      console.log('  Redirecting to login')
      router.push('/auth/login')
    }
  },

  get(request, response) {
    console.log(request)
    var url = server + request
    var startTime = Date.now()
    axios
      .get(url, {
        headers: this.get_headers(),
        cancelToken: new CancelToken(function executor(c) {
          axiosCancelFunc = c // An executor function receives a cancel function as a parameter
        }),
      })
      .then(data => {
        const duration = Date.now() - startTime

        console.log('AXIOS: got data (' + duration + 'ms):')
        response.results = data.data.items

        Vue.prototype.$mixpanel.track('GET', {
          URL: request,
          status: data.status,
          duration: duration,
          email: Vue.cookie.get('qemail'),
        })
      })
      .catch(err => this.handle_error('GET-ERROR', request, err))
  },

  cancel() {
    if (axiosCancelFunc) {
      axiosCancelFunc()
      console.log('AXIOS: request cancelled')
    }
  },

  getcb(request, cbFunc) {
    console.log('===========> ', request)

    const cacheData = this.getCacheForDemo(request)
    if (cacheData) {
      cbFunc(this.fixForDemo(request, cacheData.data))
      return
    }

    var url = server + request
    var startTime = Date.now()
    axios
      .get(url, {
        headers: this.get_headers(),
        cancelToken: new CancelToken(function executor(c) {
          axiosCancelFunc = c // An executor function receives a cancel function as a parameter
        }),
      })
      .then(data => {
        const duration = Date.now() - startTime

        console.log('THENcb got data (' + duration + 'ms):')
        Vue.prototype.$mixpanel.track('GETCB', {
          URL: request,
          status: data.status,
          duration: duration,
          email: Vue.cookie.get('qemail'),
        })

        this.setCacheForDemo(request, data)
        cbFunc(this.fixForDemo(request, data.data))
      })
      .catch(err => {
        console.log(err)
        const duration = Date.now() - startTime

        if (err.response.status === 402) {
          console.log('ERROR: PAYMENT REQUIRED')
          Vue.prototype.$mixpanel.track('GETCB-402', {
            URL: request,
            status: err.response.status,
            duration: duration,
            email: Vue.cookie.get('qemail'),
          })

          cbFunc(null)
        } else {
          this.handle_error('GETCB-ERROR', request, err)
        }
      })
  },

  /**
   *
   * @param {string} method 'post', 'put', or 'delete'
   * @param {*} request
   * @param {*} reqData
   */
  async postPutWait(method, request, reqData) {
    console.log('postPutWait ' + request)

    var url = server + request
    var startTime = Date.now()
    let resp = null
    try {
      switch (method) {
        case 'post':
          resp = await axios.post(url, reqData, { headers: this.get_headers() })
          break
        case 'put':
          resp = await axios.put(url, reqData, { headers: this.get_headers() })
          break
        case 'delete':
          resp = await axios.delete(url, { headers: this.get_headers() })
          break
        default:
          console.log('ERROR postPutWait with BAD METHOD: ', method)
      }
      const duration = Date.now() - startTime
      console.log('postPutWait got resp (' + duration + 'ms):')
      Vue.prototype.$mixpanel.track(method.toUpperCase, {
        URL: url,
        status: resp.status,
        duration: duration,
        email: Vue.cookie.get('qemail'),
      })

      return resp
    } catch (error) {
      const duration = Date.now() - startTime
      console.log('postPutWait got ERROR (' + duration + 'ms):')
      console.log(error)
      Vue.prototype.$mixpanel.track(method.toUpperCase, {
        URL: url,
        status: error.response.status,
        duration: duration,
        email: Vue.cookie.get('qemail'),
      })

      return error.response
    }
  },

  // removeEndDate(request) {
  //   const loc = request.indexOf('&end_date=')
  //   if (loc > 0) {
  //     console.log("MMMM req=", request, "loc=", loc)
  //     return request.substring(0, loc) + request.substring(loc+39)
  //   }
  //   console.log("MMMM NO LOC req=", request)
  //   return request
  // },
  getCacheForDemo(_request) {
    return null /* DISABLED */
    //   const request = this.removeEndDate(_request)
    //   /* returns the response if cached, null if not */
    //   // console.log('CACHE:', JSON.parse(JSON.stringify(demoCache)))

    //   if (request in demoCache) {
    //     console.log('CACHE GETC HIT ' + request.length + request)
    //     return JSON.parse(JSON.stringify(demoCache[request]))  // deep copy (in case the receiver changes it)
    //   }
    //   console.log('CACHE GETC MISS ' + request.length + request)
    //   return null
  },
  setCacheForDemo(_request, data) {
    /* DISABLED */
    //   const request = this.removeEndDate(_request)
    //   console.log('CACHE SETC ' + request.length + request)
    //   demoCache[request] = JSON.parse(JSON.stringify(data)) // deep copy
  },

  fixForDemo(request, data) {
    return data /* DISABLED */
    // const siteNames = {
    //   414: 'Fairport High School',
    //   671: 'Dorburn Elementary',
    //   673: 'Food Center',
    //   704: 'Norcrest Mall',
    //   705: 'Park Center',
    //   729: 'Nevins Business Center',
    //   788: 'Bellham Pl. North',
    //   819: 'Bellham Pl. South',
    //   899: 'Mullen A',
    //   915: 'Mullen B',
    // }
    // const gwNames = {
    //   1638: 'Fairport High School',
    //   2922: 'Dorburn Elementary',
    //   2886: 'Food Center',
    //   2921: 'Norcrest Mall',
    //   2942: 'Park Center',
    //   2154: 'Nevins Business Center',
    //   2514: 'Bellham Pl. North',
    //   2341: 'Bellham Pl. South',
    //   2685: 'Mullen',
    //   2926: 'Mullen',
    // }
    // console.log("ZIB ", request)
    // console.log(data)

    // if (request.startsWith('/sites')) {
    //   if (request[6] === '/') {
    //     return {
    //       ...data,
    //       city: 'Milford',
    //       address: '246 9th Ave',
    //     }
    //   }
    //   console.log("GGGGGGG ", data)
    //   data.items = data.items.map(item => {
    //     return {
    //       ...item,
    //       name: siteNames[item['id']],
    //     }
    //   })
    // }
    // if (request.startsWith('/gateways')) {
    //   if (request[9] === '/') {
    //     return {
    //       ...data,
    //       last_ip_address: '233.252.90.66',
    //     }
    //   }
    //   data.items = data.items.map(item => {
    //     console.log(item['serial'], item['name'])
    //     return {
    //       ...item,
    //       name: gwNames[item['serial']],
    //     }
    //   })
    // }

    // console.log(data)
    // return data
  },
}
